import cx from 'classnames';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import type { Optional } from '@gov-nx/core/types';
import { Button } from '../Button/Button';
import { Icon } from '../Icon';

export interface ChipNavProps {
	children: React.ReactNode;
	className?: string;
	moreChips?: Optional<boolean>;
	wcagLabel?: string;
	customClasses?: string;
}

export const ChipNav = ({
	children,
	className,
	moreChips = undefined,
	wcagLabel,
	customClasses,
}: ChipNavProps) => {
	const [showAll, setShowAll] = useState<boolean>(false);
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<div className="mt-(--templates-margin-l) mb-(--templates-margin-l)">
			<nav
				aria-label={wcagLabel}
				className={cx(
					'relative flex flex-row items-start justify-start gap-2 [ after:absolute after:top-[3px] after:w-4 after:h-10 after:bg-linear-to-l after:from-(--background-block-primary) ]',
					moreChips === undefined ? 'after:right-0' : 'after:right-[54px]',
					showAll ? '[ after:content-none ]' : undefined
				)}>
				<ul
					role="tablist"
					className={cx(
						'gov-list--plain flex gap-4 whitespace-nowrap overflow-x-auto pr-4 pt-[3px] pb-[3px]',
						customClasses,
						className && className,
						showAll ? 'flex-wrap' : undefined
					)}>
					{children}
				</ul>
				{moreChips ? (
					<Button
						onClick={() => setShowAll(!showAll)}
						color="primary"
						type="base"
						size="m"
						aria-label={t('akce.dalsi')}
						className="relative top-[3px]"
						iconStart={
							<Icon
								name={showAll ? 'chevron-up' : 'chevron-down'}
								type="components"
							/>
						}
					/>
				) : null}
			</nav>
		</div>
	);
};
